import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ICreatePostModel } from '../../../models/post.model';

@Injectable({
    providedIn: 'root',
})
export class CreatePostEventService {
    postCreatedSource = new Subject<void>();
    postCreated$ = this.postCreatedSource.asObservable();
    groupPostCreatedSource = new Subject<void>();
    groupPostCreated$ = this.groupPostCreatedSource.asObservable();
    groupPinnedPostCreatedSource = new Subject<void>();
    groupPinnedPostCreated$ = this.groupPinnedPostCreatedSource.asObservable();
    postAnsweredSource = new Subject<void>();
    postAnswered$ = this.postAnsweredSource.asObservable();
    postDeletedSource = new Subject<void>();
    postDeleted$ = this.postDeletedSource.asObservable();
    badgeSentSource = new Subject<number>();
    badgeSent$ = this.badgeSentSource.asObservable();
    postCommentCreatedSource = new Subject<void>();
    postCommentCreated$ = this.postCommentCreatedSource.asObservable();
    optimisticPostSubject = new Subject<ICreatePostModel>();
    optimisticPost$ = this.optimisticPostSubject.asObservable();

    notifyPostCreated(): void {
        this.postCreatedSource.next();
    }

    notifyGroupPostCreated(): void {
        this.groupPostCreatedSource.next();
    }

    notifyGroupPinnedPostCreated(): void {
        this.groupPinnedPostCreatedSource.next();
    }

    notifyPostAnswered(): void {
        this.postAnsweredSource.next();
    }

    notifyPostDeleted(): void {
        this.postDeletedSource.next();
    }

    notifyBadgeSent(postId: number): void {
        this.badgeSentSource.next(postId);
    }

    notifyPostCommentCreated(): void {
        this.postCommentCreatedSource.next();
    }

    emitOptimisticPost(payload: ICreatePostModel): void {
        this.optimisticPostSubject.next(payload);
    }
}
